import { useEffect, useState } from 'react'
import { Box, InputLabel, styled } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import MarkDownEditor from 'features/common/ui/MarkDownEditor/MarkDownEditor'
import { IconButton } from '@carto/meridian-ds/components'
import { EditOutlined, VisibilityOutlined } from '@mui/icons-material'
import { UseFormReturn } from 'react-hook-form'

export const MAP_DESCRIPTION_MAX_LENGTH = 500

interface Props {
  description?: string
  onChange: (description: string) => void
  form: UseFormReturn
}

const Root = styled(Box)(() => ({
  margin: 0,
  position: 'relative',
  display: 'flex',
  flexDirection: 'column'
}))

const Label = styled(InputLabel)(() => ({
  margin: 0
}))

function MapEditDialogDescription({ description, onChange, form }: Props) {
  const [previewing, setPreviewing] = useState<boolean>(false)
  const intl = useIntl()

  useEffect(() => {
    form.register('description')
  }, [form])

  const renderedDescription =
    description === undefined || description === null
      ? intl.formatMessage({ id: 'maps.edit.inputs.descriptionDefaultText' })
      : description

  return (
    <Root>
      <Box height={!previewing ? 200 : undefined} minHeight={200} maxHeight={500} flex={1}>
        <MarkDownEditor
          defaultValue={renderedDescription}
          onChange={onChange}
          preview={previewing}
          fitHeight
          label={
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={2} flex={0}>
              <Label>
                <FormattedMessage id="maps.edit.inputs.description" />
              </Label>
              <Box>
                <IconButton active={!previewing} icon={<EditOutlined />} onClick={() => setPreviewing(false)} />
                <IconButton active={previewing} icon={<VisibilityOutlined />} onClick={() => setPreviewing(true)} />
              </Box>
            </Box>
          }
          baseTypographyVariant="body2"
        />
      </Box>
    </Root>
  )
}

export default MapEditDialogDescription
